import { IonContent, IonButtons, IonList, IonCheckbox, IonTextarea, IonButton, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { imagesOutline, closeOutline, sendOutline } from 'ionicons/icons';
import { useState }  from 'react';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';

import GifContent, { LoadGifs, GifData } from "../components/GifContent";
import { LANGUAGE, GetStr } from "../language/Language";
import '../pages/Main.css'; 

export interface CommentBoxProp {
    inputRef : any;
    updateMsg : any;
    replyComment : any;
    clearReply : any;
    sendMsg : any;
    sendGif : any;
};

const CommentBox : React.FC<CommentBoxProp> = ({ inputRef, updateMsg, replyComment, clearReply, sendMsg, sendGif }) => {
    
    const [anoPost, setAnoPost] = useState(false);
    const [gif, setGif] = useState(false);
    const [gifData, setGifData] = useState<GifData>({ categories:[], gifs:[], cached_gifs:[] });
    const [selectedGif, setSelectedGif] = useState("");

    // show the gif
    const showGif = () => {
        setGif(true);
        loadGif(0);
    }

    // send gif
    const processSendGif = (gif : string) => {
        setGif(false);
        setSelectedGif(gif);
    }

    // load the gif
    const loadGif = async (cat : number) => {
        // clear first
        setGifData({ categories: gifData.categories, gifs:[], cached_gifs:[] });

        // load
        let gifs : GifData = await LoadGifs(cat);
        setGifData(gifs);
    }

    const processSendMsg = (e : any, anoPost : boolean) => {
        sendMsg(e, selectedGif, anoPost);

        if (inputRef.current != null)
        {
            if (e.clientX >= inputRef.current.getBoundingClientRect().right)
            {
                setAnoPost(false);
                setSelectedGif("");
            }
        }
    }

    return (
        <div>
            {
                replyComment != null ?
            <div>
                <IonToolbar className="reply-bar">
                    <IonLabel color="primary"><small><b>{ GetStr(LANGUAGE.TXT_CMT_REPLYING_TO) }</b></small></IonLabel>
                    <IonButton slot="end" fill="clear" onClick={clearReply}>
                        <IonIcon icon={closeOutline} />
                    </IonButton>
                </IonToolbar>
                <div className="reply-box">
                    <IonText color="medium">
                        <b>{ replyComment.user_name }</b>
                        <div className="reply-comment">{ replyComment.comment }</div>
                    </IonText>
                </div>
            </div>
                :
            <div/>
            }
            {
                selectedGif != "" ?
            <div className="reply-gif-box">
                <IonButton className="ion-float-right" fill="clear" onClick={ ()=> setSelectedGif("") }>
                    <IonIcon icon={closeOutline} />
                </IonButton>
                <IonImg className="reply-gif" src={selectedGif} /> 
            </div>
                :
            <div/>
            }
            <div className="wrapper">
                {
                    gif ?
                <GifContent content={gifData} onSend={processSendGif} onHide={ ()=>setGif(false) } onChange={loadGif}></GifContent>
                    :
                <div className="message">
                    <IonItem className="msg-box" onClick={e => processSendMsg(e, anoPost) } lines="none">
                        <IonIcon slot="start" icon={imagesOutline} onClick={showGif}></IonIcon>
                        <IonTextarea className="msg-textarea" id="input-msg" ref={inputRef} rows={1} auto-grow maxlength={500} placeholder={ GetStr(LANGUAGE.TXT_TYPE_COMMENT) } onIonChange={e => updateMsg(e.detail.value!)}></IonTextarea>
                        <IonIcon className="icon-but" slot="end" color="primary" icon={sendOutline}></IonIcon>
                    </IonItem>
                </div>
                }
                <IonItem className="bk-color" lines="none">
                    <IonCheckbox slot="start" checked={anoPost} onIonChange={(e) => setAnoPost(e.detail.checked)}></IonCheckbox>
                    <IonLabel color={ anoPost ? "dark" : "medium" }>{ GetStr(LANGUAGE.TXT_ANONYMOUS_COMMENT) }</IonLabel>
                </IonItem>
            </div>
        </div>
    );
};
  
export default CommentBox;